angular.module("vgresiduos").factory("organizationHeaderInjector", [
	"$injector",
	function ($injector) {
		"use strict";

		return {
			request: function (config) {
				if (config) {
					const accountService = $injector.get("accountService");
					const currentOrganizationUnit = accountService.getCurrentClient();
					if (currentOrganizationUnit) {
						config.headers.OrganizationUnit = currentOrganizationUnit.id;
						config.headers.Organization = currentOrganizationUnit.organization.id;
					}
				}
				return config;
			}
		};
	}
]);
